import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {User} from '../User';
import {ActivationUserRequest, ApiService, Vps} from '../api/api.service';

@Injectable()
export class VpsAdminResolver implements Resolve<Observable<Vps[]>> {

  constructor(private api: ApiService) {}

  resolve() {
    return this.api.getAdminVpsInfo();
  }
}
